import React, { useEffect, useRef, useState } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import urls from 'utils/urls'
import { makeGetRequest } from 'utils/api'
import { styled } from '@mui/material/styles'
import MuiDrawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import Pinned from 'Components/images/pinned.png'
import Add from 'Components/images/add.png'
import Png0 from 'Components/images/0.png'
import Png5 from 'Components/images/5.png'
import Png10 from 'Components/images/10.png'
import Png15 from 'Components/images/15.png'
import Png20 from 'Components/images/20.png'
import Png25 from 'Components/images/25.png'
import Png30 from 'Components/images/30.png'
import Png35 from 'Components/images/35.png'
import Png40 from 'Components/images/40.png'
import Png45 from 'Components/images/45.png'
import Png50 from 'Components/images/50.png'
import Png55 from 'Components/images/55.png'
import Png60 from 'Components/images/60.png'
import Png65 from 'Components/images/65.png'
import Png70 from 'Components/images/70.png'
import Png75 from 'Components/images/75.png'
import Png80 from 'Components/images/80.png'
import Png85 from 'Components/images/85.png'
import Png90 from 'Components/images/90.png'
import Png95 from 'Components/images/95.png'
import Png100 from 'Components/images/100.png'
import ListUserMenu from 'Components/images/list user menu.png'
import TaskUserMenu from 'Components/images/task user menu.png'
import NoteUserMenu from 'Components/images/note user menu.png'

import TaskPng from 'Components/images/Task Icon big.png'
import ProjectPng from 'Components/images/Project icone Big.png'
import ListIconPng from 'Components/images/List icone big.png'
import NoteIconPng from 'Components/images/Note Icone Big.png'
import Collapse from '@mui/material/Collapse'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Modal from '@mui/material/Modal'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import CreateTache from './CreateTache'
import CreateNote from './CreateNote'
import { MesTaches } from './MesTaches'
import { MNotes } from './MNotes'
import CreateProject from './CreateProject'
import { MesProjects } from './MesProjects'
import CreateListe from './CreateListe'
import { MesListe } from './MesListe'
import SyntheseTaches from './SyntheseTaches'
import CircularProgress from '@mui/material/CircularProgress'
import MenuIcon from '@mui/icons-material/Menu'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
}
const drawerWidth = 230

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  top: 'unset',
  // height: '87vh',
  background: '#4975c1',
  overflowX: 'hidden',
})

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  top: 'unset',
  // height: '87vh',
  background: '#4975c1',
  overflowX: 'hidden',
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
})

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}))

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
)

function AddModal(props) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Modal
      open={props.modelOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ '.maintachm': { borderRadius: 2, width: isMobile ? '90%' : '500px' } }}
    >
      <Box sx={mstyle} className="maintachm">
        <Box>
          <Box
            sx={{
              textAlign: 'end',
              padding: '5px 10px',
            }}
          >
            <CloseIcon
              sx={{
                cursor: 'pointer',
              }}
              onClick={props.handleModelClose}
            />
          </Box>
          <Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                cursor: 'pointer',
                ':hover': {
                  background: '#f3f3f3',
                },
              }}
              onClick={() => props.CreateTacheModal()}
            >
              <Box
                sx={{
                  padding: '0 15px',
                }}
              >
                <img alt="" src={TaskPng} />
              </Box>
              <Box>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: 'black !important',
                    textAlign: 'left',
                  }}
                  variant="h6"
                  component="h3"
                >
                  {t('mesToDo.newTask')}
                </Typography>
                <Typography id="modal-modal-description">
                  {t('mesToDo.newTaskHint')}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                cursor: 'pointer',
                ':hover': {
                  background: '#f3f3f3',
                },
              }}
              onClick={() => props.CreateProjectModal()}
            >
              <Box
                sx={{
                  padding: '0 15px',
                  width: '108px',
                }}
              >
                <img alt="" src={ProjectPng} />
              </Box>
              <Box>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: 'black !important',
                    textAlign: 'left',
                  }}
                  variant="h6"
                  component="h3"
                >
                  {t('mesToDo.newProject')}
                </Typography>
                <Typography id="modal-modal-description">
                  {t('mesToDo.newProjectHint')}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                cursor: 'pointer',
                ':hover': {
                  background: '#f3f3f3',
                },
              }}
              onClick={() => props.CreateListeModal()}
            >
              <Box
                sx={{
                  padding: '0 15px',
                }}
              >
                <img alt="" src={ListIconPng} />
              </Box>
              <Box>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: 'black !important',
                    textAlign: 'left',
                  }}
                  variant="h6"
                  component="h3"
                >
                  {t('mesToDo.newList')}
                </Typography>
                <Typography id="modal-modal-description">
                  {t('mesToDo.newListHint')}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                cursor: 'pointer',
                ':hover': {
                  background: '#f3f3f3',
                },
              }}
              onClick={() => props.CreateNoteModal()}
            >
              <Box
                sx={{
                  padding: '0 15px',
                }}
              >
                <img alt="" src={NoteIconPng} />
              </Box>
              <Box>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: 'black !important',
                    textAlign: 'left',
                  }}
                  variant="h6"
                  component="h3"
                >
                  {t('mesToDo.newNote')}
                </Typography>
                <Typography id="modal-modal-description">
                  {t('mesToDo.newNoteHint')}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export const MesToDo = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [openDrawer, setOpenDrawer] = useState(false)
  const [taskCat, setTaskCat] = useState('')
  const [projectTaskId, setProjectTaskId] = useState('')
  const [listeTaskId, setListeTaskId] = useState('')
  const [projectTaskName, setProjectTaskName] = useState('')
  const [listeTaskName, setListeTaskName] = useState('')
  const [priorite, setPriorite] = useState('')
  const [taskstatus, setStatus] = useState('')
  // SmartFeed — filtre de la liste des projets porté par le lien de la carte
  // (''=tous · 'sleeping'=projets sans action depuis 30 jours).
  const [projectFilter, setProjectFilter] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const handledUrlActionRef = useRef(null)
  const [project, setProject] = useState(false)
  const [noteRow, setNoteRow] = useState({})
  const [projectRow, setProjectRow] = useState({})
  const [listeRow, setListeRow] = useState({})
  const [listes, setListes] = useState(false)
  const [taches, setTaches] = useState(false)
  const [notes, setNotes] = useState(false)
  // LAP — navigation des tâches par type (livrable / habitude / compétence / kpi)
  const [byType, setByType] = useState(false)
  const [typeFilter, setTypeFilter] = useState('')
  const [typeCounts, setTypeCounts] = useState({
    livrable: 0,
    habitude: 0,
    competence: 0,
    kpi: 0,
  })
  const [notesList, setNotesList] = useState([])
  const [projectList, setProjectList] = useState([])
  const [tasksList, setTasksList] = useState([])
  const [listeList, setListeList] = useState([])
  const [createTache, setCreateTache] = useState(false)
  const [createNote, setCreateNote] = useState(false)
  const [createProject, setCreateProject] = useState(false)
  // LAP-fix-projet-vs-objectif — Le prefill arrive via location.state quand on
  // ouvre CreateProject depuis le Conseiller Patrimonial. Comme le handler
  // d'URL fait navigate('projects', { replace: true }) (ce qui efface
  // location.state), on capture le prefill ici AVANT la redirection pour qu'il
  // survive jusqu'au rendu de <CreateProject prefill=... />.
  const [projectPrefill, setProjectPrefill] = useState(null)
  const [createListe, setCreateListe] = useState(false)
  const [modelOpen, setModelOpen] = useState(false)
  const [updateSynthese, setUpdateSynthese] = useState(false)
  const [editNote, setEdit] = useState(false)
  const [loadingDone, setLoadingDone] = useState(false)

  const [tasks1, setTasks1] = useState([])
  const [tasks2, setTasks2] = useState([])
  const [tasks3, setTasks3] = useState([])
  const [tasks4, setTasks4] = useState([])
  const [tasks5, setTasks5] = useState([])

  const IconPng = ({ row }) => {
    let total = row.tasks.length
    let done = 0
    row.tasks.map((v) => {
      if (v.Done) done++
      return ''
    })
    let num = parseFloat((done === 0 ? 0 : (done / total) * 100).toFixed(2))

    let png = Png0
    if (num > 2.5) png = Png5

    if (num > 7.5) png = Png10

    if (num > 12.5) png = Png15

    if (num > 17.5) png = Png20

    if (num > 22.5) png = Png25

    if (num > 27.5) png = Png30

    if (num > 32.5) png = Png35

    if (num > 37.5) png = Png40

    if (num > 42.5) png = Png45

    if (num > 47.5) png = Png50

    if (num > 52.5) png = Png55

    if (num > 57.5) png = Png60

    if (num > 62.5) png = Png65

    if (num > 67.5) png = Png70

    if (num > 72.5) png = Png75

    if (num > 77.5) png = Png80

    if (num > 82.5) png = Png85

    if (num > 87.5) png = Png90

    if (num > 92.5) png = Png95

    if (num > 98) png = Png100

    return <img alt="" style={{ padding: '0px', margin: '0 5px 1px 0px' }} src={png} />
  }

  const handleModelOpen = () => {
    setModelOpen(true)
    setProjectTaskId('')
  }
  const handleModelClose = () => setModelOpen(false)
  useEffect(() => {
    getData()

    // fetchTasks1()
    // fetchTasks2()
    // fetchTasks3()
    // fetchTasks4()
    // fetchTasks5()
  }, [])
  const getData = async () => {
    setLoadingDone(false)
    await fetchNotesList()
    await fetchProjectList()
    await fetchListeList()
    await fetchTasksList()
    await fetchTypeCounts()
    setLoadingDone(true)
  }

  // LAP — compte les tâches de chaque type pour les badges du menu "Par type".
  // On lit le `count` renvoyé par la pagination (limit=1 pour limiter le payload).
  const fetchTypeCounts = async () => {
    const types = ['livrable', 'habitude', 'competence', 'kpi']
    const counts = {}
    await Promise.all(
      types.map(async (type) => {
        const { data, status } = await makeGetRequest(
          urls.taskOperations + `?TypeTache=${type}&limit=1`,
          {},
          true,
        )
        counts[type] = status === 200 ? data.count || 0 : 0
      }),
    )
    setTypeCounts(counts)
  }

  const updateTodo = async () => {
    setLoadingDone(false)
    setUpdateSynthese(!updateSynthese)
    await fetchNotesList()
    await fetchProjectList()
    await fetchListeList()
    await fetchTasksList()

    await fetchTasks1()
    await fetchTasks2()
    await fetchTasks3()
    await fetchTasks4()
    await fetchTasks5()
    await fetchTypeCounts()

    setLoadingDone(true)
  }
  const fetchTasks1 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat1&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks1(data.results)
    }
  }
  const fetchTasks2 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat2&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks2(data.results)
    }
  }
  const fetchTasks3 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat3&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks3(data.results)
    }
  }
  const fetchTasks4 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat4&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks4(data.results)
    }
  }
  const fetchTasks5 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat5&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks5(data.results)
    }
  }
  const fetchTasksList = async (pagination = '') => {
    let url = `${urls.taskOperations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setTasksList(response.data.results)
    }
  }
  const fetchNotesList = async (pagination = '') => {
    let url = `${urls.noteOperations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setNotesList(response.data.results)
    }
  }
  const fetchProjectList = async (pagination = '') => {
    let url = `${urls.projectOperations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setProjectList(response.data.results)
    }
  }
  const fetchListeList = async (pagination = '') => {
    let url = `${urls.listeOperations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setListeList(response.data.results)
    }
  }
  const handleSynthese = () => {
    setProject(false)
    setNotes(false)
    setTaches(false)
    setListes(false)
    setByType(false)
  }
  const handleProject = () => {
    setProject(true)
    setNotes(false)
    setTaches(false)
    setListes(false)
    setByType(false)
    // Navigation « projets » normale → on repart sans filtre (tous les projets).
    // Le filtre « en sommeil » est réappliqué juste après par le handler d'URL.
    setProjectFilter('')
  }
  const handleListes = () => {
    setListes(true)
    setProject(false)
    setNotes(false)
    setTaches(false)
    setByType(false)
  }
  const handleTaches = () => {
    setTaches(true)
    setProject(false)
    setNotes(false)
    setListes(false)
    setByType(false)
  }
  const handleNotes = () => {
    setNotes(true)
    setProject(false)
    setTaches(false)
    setListes(false)
    setByType(false)
  }
  // LAP — ouvre la section "Par type" (et referme les autres)
  const handleByType = () => {
    setByType(true)
    setProject(false)
    setNotes(false)
    setTaches(false)
    setListes(false)
  }
  // LAP — sélectionne un type de tâche et bascule sur la liste filtrée
  const handleTypeFilter = (type) => {
    setTypeFilter(type)
    setProjectTaskId('')
    setListeTaskId('')
    setTaskCat('')
    setPriorite('')
    setStatus('')
    navigate('taches')
  }
  const CreateTacheModal = () => {
    setCreateTache(true)
    setModelOpen(false)
  }
  const CreateNoteModal = (edit = false) => {
    // console.log(edit)
    setEdit(edit)
    setCreateNote(true)
    setModelOpen(false)
  }
  const CreateProjectModal = () => {
    setCreateProject(true)
    setModelOpen(false)
  }
  const CreateListeModal = () => {
    setCreateListe(true)
    setModelOpen(false)
  }
  const handleDrawerOpen = () => {
    setOpen(true)
  }
  const handleDrawerClose = () => {
    setOpen(false)
  }
  useEffect(() => {
    if (!loadingDone) return

    const searchParams = new URLSearchParams(location.search)
    const action = searchParams.get('action')
    const modal = searchParams.get('modal')
    const urlAction = action || modal
    const actionKey = `${location.pathname}${location.search}`

    if (handledUrlActionRef.current === actionKey) return

    if (urlAction === 'new-note') {
      handledUrlActionRef.current = actionKey
      handleNotes()
      handleDrawerOpen()
      navigate('note', { replace: true })
      CreateNoteModal()
    }
    if (urlAction === 'new-project') {
      handledUrlActionRef.current = actionKey
      // Capture le prefill avant la redirection (navigate efface location.state).
      setProjectPrefill(location.state?.prefill || null)
      handleProject()
      handleDrawerOpen()
      navigate('projects', { replace: true })
      CreateProjectModal()
    }
    if (urlAction === 'new-task') {
      handledUrlActionRef.current = actionKey
      handleTaches()
      handleDrawerOpen()
      navigate('taches', { replace: true })
      CreateTacheModal()
    }

    // SmartFeed — filtre porté par le lien de la publication (?filter=…).
    // Chaque carte du fil pointe vers /todos?filter=<nom> pour que la liste
    // n'affiche QUE les éléments pertinents (au lieu de tout : fait, en cours…).
    // On réutilise les catégories existantes du backend (task=catX) et le
    // statut (Statut=Fait) plutôt que d'inventer un mécanisme parallèle.
    const filter = searchParams.get('filter')
    if (filter && !urlAction) {
      // Table de correspondance vers les filtres déjà compris par MesTaches :
      //   cat1=En-Cours · cat2=Important · cat3=Non démarré · cat4=Sans échéance
      //   cat5=En-retard · Statut=Fait=Terminées.
      const TASK_CAT_FILTERS = {
        overdue: 'cat5', // tâches en retard
        'en-retard': 'cat5',
        'due-soon': 'cat6', // échéance sous 7 jours (hors terminées)
        echeance: 'cat6',
        'echeance-proche': 'cat6',
        'done-week': 'cat7', // terminées sur les 7 derniers jours (SmartFeed 309)
        'accompli-semaine': 'cat7',
        'in-progress': 'cat1', // en cours
        'en-cours': 'cat1',
        'not-started': 'cat3', // non démarrées
        'non-demarre': 'cat3',
        anytime: 'cat4', // sans échéance
        important: 'cat2', // important / urgent
        today: 'cat8', // échéance = aujourd'hui, non terminées (carte du matin)
        aujourdhui: 'cat8',
        'aujourd-hui': 'cat8',
        'to-reorganize': 'cat9', // échéance <= aujourd'hui, non terminées (carte du soir)
        'a-reorganiser': 'cat9',
        reste: 'cat9',
        'due-recent': 'cat10', // échéance J-2/J-1/J, non terminées (carte « échéances fraîches »)
        'echeance-recente': 'cat10',
      }
      // « done »/« fait » = TOUTES les terminées ; « done-week » passe par
      // TASK_CAT_FILTERS (cat7) pour ne garder que les 7 derniers jours.
      const DONE_FILTERS = ['done', 'fait', 'termine', 'terminees']
      // Projets : liste complète.
      const PROJECT_FILTERS = ['projects', 'projet', 'projets']
      // Projets « en sommeil » : sans action depuis 30 jours (?sleeping=1).
      const SLEEPING_FILTERS = ['sleeping', 'sommeil', 'dormant', 'inactif']
      // LAP recherche globale — sections sans filtre de catégorie : toutes les
      // tâches / toutes les listes (le résultat ciblé est surligné via ?focus).
      const TASK_ALL_FILTERS = ['tasks', 'taches', 'tâches']
      const LIST_FILTERS = ['lists', 'liste', 'listes']
      // LAP recherche globale — on préserve `?focus=<id>` lors de la
      // redirection interne pour que useFocusHighlight surligne la ligne visée.
      const focus = searchParams.get('focus')
      const withFocus = (path) =>
        focus ? { pathname: path, search: `?focus=${focus}` } : path

      const goTaches = () => {
        // On repart d'un filtre propre pour éviter les cumuls résiduels.
        setProjectTaskId('')
        setListeTaskId('')
        setTypeFilter('')
        setPriorite('')
        handleTaches()
      }

      if (TASK_CAT_FILTERS[filter]) {
        handledUrlActionRef.current = actionKey
        goTaches()
        setTaskCat(TASK_CAT_FILTERS[filter])
        setStatus('')
        navigate(withFocus('taches'), { replace: true })
      } else if (DONE_FILTERS.includes(filter)) {
        handledUrlActionRef.current = actionKey
        goTaches()
        setTaskCat('') // pas de catégorie → toutes les tâches…
        setStatus('Fait') // …filtrées sur le statut Terminé (filterset Statut).
        navigate(withFocus('taches'), { replace: true })
      } else if (TASK_ALL_FILTERS.includes(filter)) {
        // LAP recherche globale — toutes les tâches, la ligne ciblée surlignée.
        handledUrlActionRef.current = actionKey
        goTaches()
        setTaskCat('')
        setStatus('')
        navigate(withFocus('taches'), { replace: true })
      } else if (SLEEPING_FILTERS.includes(filter)) {
        handledUrlActionRef.current = actionKey
        handleProject() // remet projectFilter à '' …
        setProjectFilter('sleeping') // … puis réapplique le filtre « en sommeil ».
        navigate(withFocus('projects'), { replace: true })
      } else if (PROJECT_FILTERS.includes(filter)) {
        handledUrlActionRef.current = actionKey
        handleProject() // remet projectFilter à '' …
        // Carte « Des projets sans objectif » — /todos?filter=projects&no_objective=1 :
        // la liste ne garde que les projets actifs rattachés à aucun objectif.
        if (searchParams.get('no_objective')) {
          setProjectFilter('no_objective')
        }
        navigate(withFocus('projects'), { replace: true })
      } else if (LIST_FILTERS.includes(filter)) {
        // LAP recherche globale — ouvre la section Listes.
        handledUrlActionRef.current = actionKey
        handleListes()
        navigate(withFocus('liste'), { replace: true })
      }
    }
  }, [loadingDone, location.pathname, location.search, navigate])
  const updateTodoList = (cat, data) => {
    if (cat === 'cat1') setTasks1(data)
    if (cat === 'cat2') setTasks2(data)
    if (cat === 'cat3') setTasks3(data)
    if (cat === 'cat4') setTasks4(data)
    if (cat === 'cat5') setTasks5(data)
  }
  const handleMesTaches = (priorite = '', status = '') => {
    setProjectTaskId('')
    setListeTaskId('')
    setTaskCat('')
    setTypeFilter('')
    setPriorite(priorite)
    setStatus(status)
    handleTaches()
    navigate('taches')
  }
  function trimText(text) {
    if (text.length > 35) {
      return text.substring(0, 35) + '...' // Trim and append ellipsis
    }
    return text // Return original text if it's within the limit
  }
  const handelMobileClose = () => {
    if (isMobile) {
      setOpenDrawer(false)
    }
  }
  useEffect(() => {
    if (isMobile) {
      setOpen(true)
      setOpenDrawer(false)
    } else {
      setOpenDrawer(true)
    }
  }, [isMobile])
  return (
    <>
      <Box ml={2}>
        {isMobile && (
          <MenuIcon onClick={() => setOpenDrawer(!openDrawer)} sx={{ color: 'white' }} />
        )}
      </Box>
      <Box sx={{ display: 'flex', overflow: 'hidden', width: '100%' }}>
        {/* <CssBaseline /> */}

        <Drawer
          variant="permanent"
          open={open}
          sx={{
            display: openDrawer ? 'block' : 'none',
            height: 'auto',
            width: open ? (isMobile ? '100%' : '365px') : '60px',
            '.MuiDrawer-paper': { width: open ? (isMobile ? '100%' : '365px') : '60px' },
          }}
        >
          <DrawerHeader sx={{ justifyContent: 'flex-start' }}>
            {open ? (
              <>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      width: '-webkit-fill-available',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        handleModelOpen()
                        handelMobileClose()
                      }}
                    >
                      <img alt="" src={Add} />
                    </IconButton>
                    {!isMobile && (
                      <IconButton onClick={handleDrawerClose}>
                        <img alt="" src={Pinned} />
                      </IconButton>
                    )}
                  </Box>
                  {/* <Box
                  sx={{
                    '& input': {
                      background: '#4975c1',
                      border: '1px solid white',
                      outline: 'unset',
                      borderRadius: '5px',
                      color: 'white',
                    },
                    '& input::placeholder': {
                      color: '#90bce3',
                      padding: '0 6px',
                    },
                  }}
                >
                  <input name="search" placeholder="Recherche" />
                </Box> */}
                </Box>
              </>
            ) : (
              <>
                <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                  <IconButton onClick={handleDrawerOpen}>
                    <ChevronRightIcon sx={{ color: 'white' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleModelOpen()
                      handelMobileClose()
                    }}
                  >
                    <img alt="" src={Add} />
                  </IconButton>
                  {/* <IconButton onClick={handleDrawerOpen}>
                  <SearchIcon sx={{ color: 'white' }} />
                </IconButton> */}
                </Box>
              </>
            )}
          </DrawerHeader>
          <Divider />
          {open ? (
            <>
              <List
                sx={{ px: 1, color: 'white' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton>
                  <ListItemText
                    onClick={() => {
                      navigate('')
                      handleSynthese()
                      handelMobileClose()
                    }}
                    primary={t('mesToDo.menuSynthesisTasks')}
                  />
                </ListItemButton>
                <ListItemButton
                  sx={{ padding: '0 5px' }}
                  onClick={() => {
                    handleProject()
                    navigate('projects')
                    handelMobileClose()
                  }}
                >
                  {project ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText sx={{ marginLeft: '5px' }} primary={t('mesToDo.menuMyProjects')} />
                  <ListItemText sx={{ textAlign: 'end' }} primary={projectList.length} />
                </ListItemButton>
                <Collapse in={project} timeout="auto" unmountOnExit>
                  {projectList.map((v) => (
                    <List key={v.id} component="div" disablePadding>
                      <ListItemButton
                        sx={{ padding: '0 8px' }}
                        onClick={() => {
                          setProjectTaskId(v.id)
                          setProjectTaskName(v.Name)

                          setListeTaskId('')
                          setTaskCat('')
                          setPriorite('')
                          setStatus('')
                          setTypeFilter('')
                          setProjectRow(v)
                          navigate('taches')
                          handelMobileClose()
                        }}
                      >
                        <IconPng row={v} />
                        <ListItemText primary={v.Name} />
                        <ListItemText sx={{ textAlign: 'end' }} primary={v.tasks.length} />
                      </ListItemButton>
                    </List>
                  ))}
                </Collapse>
                <ListItemButton
                  sx={{ padding: '0 5px', marginTop: '15px' }}
                  onClick={() => {
                    // setProjectTaskId('')
                    // setListeTaskId('')
                    handleListes()
                    navigate('liste')
                    handelMobileClose()
                  }}
                >
                  {listes ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText sx={{ marginLeft: '5px' }} primary={t('mesToDo.menuMyLists')} />
                  <ListItemText sx={{ textAlign: 'end' }} primary={listeList.length} />
                </ListItemButton>
                <Collapse in={listes} timeout="auto" unmountOnExit>
                  {listeList.map((v) => (
                    <List key={v.id} component="div" disablePadding>
                      <ListItemButton
                        sx={{ padding: '0 8px' }}
                        onClick={() => {
                          setListeTaskId(v.id)
                          setListeTaskName(v.Name)
                          setProjectTaskId('')
                          setTaskCat('')
                          setPriorite('')
                          setStatus('')
                          setTypeFilter('')
                          setListeRow(v)
                          navigate('taches')
                          handelMobileClose()
                        }}
                      >
                        <img
                          alt=""
                          style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                          src={ListUserMenu}
                        />
                        <ListItemText primary={trimText(v.Name)} />
                        <ListItemText sx={{ textAlign: 'end' }} primary={v.tasks.length} />
                      </ListItemButton>
                    </List>
                  ))}
                </Collapse>
                <ListItemButton
                  sx={{ padding: '0 5px', marginTop: '15px' }}
                  onClick={() => {
                    handleTaches()
                    // navigate('taches')
                    handleMesTaches()
                  }}
                >
                  {taches ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText sx={{ marginLeft: '5px' }} primary={t('mesToDo.menuMyTasks')} />
                  <ListItemText sx={{ textAlign: 'end' }} primary={tasksList.length} />
                </ListItemButton>
                <Collapse in={taches} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat1')
                        setTypeFilter('')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        handelMobileClose()
                        navigate('taches')
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterToday')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks1.length} />
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat2')
                        setTypeFilter('')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        navigate('taches')
                        handelMobileClose()
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterImportant')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks2.length} />
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat3')
                        setTypeFilter('')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        navigate('taches')
                        handelMobileClose()
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterUpcoming')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks3.length} />
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat4')
                        setTypeFilter('')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        navigate('taches')
                        handelMobileClose()
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterAnytime')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks4.length} />
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat5')
                        setTypeFilter('')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        navigate('taches')
                        handelMobileClose()
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterUnclassified')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks5.length} />
                    </ListItemButton>
                  </List>
                </Collapse>
                {/* LAP — navigation des tâches par type */}
                <ListItemButton
                  sx={{ padding: '0 5px', marginTop: '15px' }}
                  onClick={() => {
                    handleByType()
                  }}
                >
                  {byType ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText sx={{ marginLeft: '5px' }} primary={t('mesToDo.menuByType')} />
                  <ListItemText
                    sx={{ textAlign: 'end' }}
                    primary={
                      typeCounts.livrable +
                      typeCounts.habitude +
                      typeCounts.competence +
                      typeCounts.kpi
                    }
                  />
                </ListItemButton>
                <Collapse in={byType} timeout="auto" unmountOnExit>
                  {[
                    { id: 'livrable', label: t('mesToDo.menuTypeLivrables'), count: typeCounts.livrable },
                    { id: 'habitude', label: t('mesToDo.menuTypeHabitudes'), count: typeCounts.habitude },
                    {
                      id: 'competence',
                      label: t('mesToDo.menuTypeCompetences'),
                      count: typeCounts.competence,
                    },
                    { id: 'kpi', label: t('mesToDo.menuTypeKpis'), count: typeCounts.kpi },
                  ].map((tt) => (
                    <List key={tt.id} component="div" disablePadding>
                      <ListItemButton
                        sx={{ padding: '0 8px' }}
                        selected={typeFilter === tt.id}
                        onClick={() => {
                          handleTypeFilter(tt.id)
                          handelMobileClose()
                        }}
                      >
                        <img
                          alt=""
                          style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                          src={TaskUserMenu}
                        />
                        <ListItemText primary={tt.label} />
                        <ListItemText sx={{ textAlign: 'end' }} primary={tt.count} />
                      </ListItemButton>
                    </List>
                  ))}
                </Collapse>
                <ListItemButton
                  sx={{ padding: '0 5px', marginTop: '15px' }}
                  onClick={() => {
                    // setProjectTaskId('')
                    // setListeTaskId('')
                    handleNotes()
                    // handelMobileClose()
                  }}
                >
                  {notes ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText sx={{ marginLeft: '5px' }} primary={t('mesToDo.menuMyNotes')} />
                  <ListItemText sx={{ textAlign: 'end' }} primary={notesList.length} />
                </ListItemButton>
                <Collapse in={notes} timeout="auto" unmountOnExit>
                  {notesList.map((v) => (
                    <List key={v.id} component="div" disablePadding>
                      <ListItemButton
                        sx={{ padding: '0 8px' }}
                        onClick={() => {
                          setNoteRow(v)
                          navigate('note')
                          handelMobileClose()
                        }}
                      >
                        <img
                          alt=""
                          style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                          src={NoteUserMenu}
                        />
                        <ListItemText primary={v.Titre} />
                      </ListItemButton>
                    </List>
                  ))}
                </Collapse>
                
                {/* Shopping List Link */}
                <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.1)' }} />
                <ListItemButton
                  sx={{ 
                    padding: '12px 15px',
                    borderRadius: '8px',
                    mx: 1,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #7e8ef5 0%, #8b5db8 100%)',
                    }
                  }}
                  onClick={() => {
                    window.location.href = '/shopping'
                  }}
                >
                  <ShoppingCartIcon sx={{ mr: 1, color: 'white' }} />
                  <ListItemText 
                    primary={t('mesToDo.menuShoppingLists')}
                    sx={{ 
                      '& .MuiListItemText-primary': { 
                        fontWeight: 600,
                        color: 'white'
                      } 
                    }} 
                  />
                </ListItemButton>
              </List>
            </>
          ) : (
            <>
              <List
                sx={{ width: '100%', maxWidth: 200, color: 'white', height: '100%' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <Box
                  sx={{
                    height: '80%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    sx={{ marginTop: 'auto', transformOrigin: '0 0', transform: 'rotate(270deg)' }}
                  >
                    <ListItemButton sx={{ width: 'fit-content' }}>
                      <ListItemText
                        onClick={() => {
                          navigate('')
                          handelMobileClose()
                        }}
                        primary={t('mesToDo.menuSynthesisTasks')}
                      />
                    </ListItemButton>
                  </Box>
                  <Box marginTop={''}>
                    <ListItemButton
                      onClick={() => {
                        setProjectTaskId('')
                        setListeTaskId('')
                        setTaskCat('')
                        setStatus('')
                        setPriorite('')
                        handleTaches()
                        navigate('taches')
                        handelMobileClose()
                      }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => {
                        // setProjectTaskId('')
                        // setListeTaskId('')
                        handleProject()
                        navigate('projects')
                        handelMobileClose()
                      }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={Png100}
                      />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => {
                        // setProjectTaskId('')
                        // setListeTaskId('')
                        handleListes()
                        navigate('liste')
                        handelMobileClose()
                      }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={ListUserMenu}
                      />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => {
                        // setProjectTaskId('')
                        // setListeTaskId('')
                        handleNotes()
                        handleDrawerOpen()
                        handelMobileClose()
                      }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={NoteUserMenu}
                      />
                    </ListItemButton>
                    {/* Shopping List Link - Collapsed View */}
                    <ListItemButton
                      onClick={() => {
                        window.location.href = '/shopping'
                      }}
                      sx={{
                        mt: 2,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '8px',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #7e8ef5 0%, #8b5db8 100%)',
                        }
                      }}
                    >
                      <ShoppingCartIcon sx={{ color: 'white' }} />
                    </ListItemButton>
                  </Box>
                </Box>
              </List>
            </>
          )}
        </Drawer>
        <Box component="main" sx={{ flexGrow: 10, p: 0 }}>
          {/* {false ? ( */}
          {loadingDone === true ? (
            <Routes>
              <Route
                path="/"
                element={
                  <SyntheseTaches
                    open={open}
                    updateSynthese={updateSynthese}
                    handleMesTaches={handleMesTaches}
                    updateTodo={updateTodoList}
                  />
                }
              />
              <Route
                path="/taches"
                element={
                  <MesTaches
                    CreateTacheModal={CreateTacheModal}
                    updateTodo={updateTodo}
                    createTache={createTache}
                    projectTaskName={projectTaskName}
                    taskCat={taskCat}
                    typeFilter={typeFilter}
                    projectTaskId={projectTaskId}
                    listeTaskId={listeTaskId}
                    listeTaskName={listeTaskName}
                    Priorite={priorite}
                    taskstatus={taskstatus}
                    setPriorite={setPriorite}
                    setStatus={setStatus}
                    updateTodoList={updateTodoList}
                  />
                }
              />
              <Route
                path="/note"
                element={
                  <MNotes
                    row={noteRow}
                    CreateTacheModal={CreateTacheModal}
                    updateTodo={updateTodo}
                    setNoteRow={setNoteRow}
                    CreateNoteModal={CreateNoteModal}
                    notesList={notesList}
                    setNotesList={setNotesList}
                  />
                }
              />
              <Route
                path="/projects"
                element={
                  <MesProjects
                    CreateProjectModal={CreateProjectModal}
                    updateTodo={updateTodo}
                    createProject={createProject}
                    setProjectTaskId={setProjectTaskId}
                    setProjectTaskName={setProjectTaskName}
                    projectFilter={projectFilter}
                  />
                }
              />
              <Route
                path="/liste"
                element={
                  <MesListe
                    CreateListeModal={CreateListeModal}
                    updateTodo={updateTodo}
                    createListe={createListe}
                    setListeTaskId={setListeTaskId}
                    setListeTaskName={setListeTaskName}
                  />
                }
              />
            </Routes>
          ) : (
            <Box
              sx={{
                display: 'flex',
                height: '90vh',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Box>
        <AddModal
          modelOpen={modelOpen}
          CreateProjectModal={CreateProjectModal}
          CreateListeModal={CreateListeModal}
          updateTodo={updateTodo}
          handleModelClose={handleModelClose}
          CreateTacheModal={CreateTacheModal}
          CreateNoteModal={CreateNoteModal}
        />
        {createTache && (
          <CreateTache
            setCreateTache={setCreateTache}
            projectTaskId={projectTaskId}
            updateTodo={updateTodo}
            listeTaskId={listeTaskId}
          />
        )}
        {createNote && (
          <CreateNote
            setCreateNote={setCreateNote}
            setNoteRow={setNoteRow}
            updateTodo={updateTodo}
            setNotesList={setNotesList}
            setEdit={setEdit}
            editNote={editNote}
          />
        )}
        {createProject && (
          <CreateProject
            setCreateProject={setCreateProject}
            setProjectRow={setProjectRow}
            updateTodo={updateTodo}
            setProjectList={setProjectList}
            /* LAP-fix-projet-vs-objectif — Quand on ouvre CreateProject depuis
               le Conseiller Patrimonial via /todos?action=new-project, le
               prefill (Name / Objectifs / DateFinObjectif / LifeDomain) est
               capturé dans projectPrefill par le handler d'URL, car
               navigate('projects', { replace: true }) efface location.state. */
            prefill={projectPrefill}
          />
        )}
        {createListe && (
          <CreateListe
            setCreateListe={setCreateListe}
            setListeList={setListeList}
            updateTodo={updateTodo}
          />
        )}
      </Box>
    </>
  )
}
